module.exports = __webpack_public_path__ + "img/monitor.eeae0377.jpg";